import { createContext } from 'react';
import {
    QUERY_KEYS_SECURITY,
    useChartsData
} from '../../../../Common/hooks/useChartsData';
import { useSecurityFiltersContext } from '../../../Common/Filters/hooks/useSecurityFiltersContext';

export const MilitaryChartsDataContext = createContext();

const MilitaryChartsDataProvider = ({ children }) => {
    const { filters } = useSecurityFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
            year: filters.year?.value || '',
            month: filters.month?.value ? String(Number(filters.month?.value)) : "",
            location: filters.unidade.value,
            city: filters.cidade?.value,
    }

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.BATTALION_EVOLUTION,
            url: 'governanceroom/securitydashboard/criminalData/military/battalionEvolution'
        },
        filterParams
    );

    const commandEvolution = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.COMMAND_EVOLUTION,
            url: 'governanceroom/securitydashboard/criminalData/military/commandEvolution'
        },
        filterParams
    );

    const companyEvolution = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.COMPANY_EVOLUTION,
            url: 'governanceroom/securitydashboard/criminalData/military/companyEvolution'
        },
        filterParams
    );

    const chartData = {
        battalionEvolutionAnual: data?.anualEvolution || [],
        battalionEvolutionMonth: data?.monthEvolution || [],
        commandEvolutionAnual: commandEvolution?.data?.anualEvolution || [],
        commandEvolutionMonth: commandEvolution?.data?.monthEvolution || [],
        companyEvolutionAnual: companyEvolution?.data?.anualEvolution || [],
        companyEvolutionMonth: companyEvolution?.data?.monthEvolution || []
    }

    return (
        <MilitaryChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </MilitaryChartsDataContext.Provider>
    );
};

export default MilitaryChartsDataProvider;
